import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';
import {NavLink} from 'react-router-dom';
import {Profile} from '../../interfaces';
import {useTranslation} from 'react-i18next';
import {getBirthdayDisplayText} from '../../services/dateService';

interface Props {
  familyMembers: Profile[];
  showPlayerSessionsLink?: boolean;
  showMembershipLink?: boolean;
  showMembershipLinkReload?: boolean;
}

const FamilyMemberList: React.FC<Props> = ({
  familyMembers,
  showPlayerSessionsLink,
  showMembershipLink,
  showMembershipLinkReload,
}) => {
  const {t} = useTranslation();

  return (
    <TableContainer sx={{mb: 1}} component={Paper}>
      <Table aria-label={t('ariaLabels.tables.familyMembersList') as string}>
        <TableHead>
          <TableRow>
            <TableCell>{t('general.name')}</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...(familyMembers ?? [])].map(child => (
            <TableRow key={child.id}>
              <TableCell>
                {child.firstName
                  ? `${child.firstName} ${child.lastName}`
                  : t('familyMemberList.newUnnamedFamilyMember', {
                      dob: getBirthdayDisplayText(child.dateOfBirth),
                    })}
              </TableCell>
              <TableCell align="right">
                {showPlayerSessionsLink && (
                  <Button
                    component={NavLink}
                    to={`/family/children/${child.id}/playersessions`}>
                    {t('pages.playerSessions')}
                  </Button>
                )}
                {showMembershipLink && (
                  <Button
                    component={NavLink}
                    to={`/family/children/${child.id}/membership`}>
                    {t('pages.membership')}
                  </Button>
                )}
                {showMembershipLinkReload && (
                  <Button
                    onClick={() => {
                      window.location.pathname = `/family/children/${child.id}/membership`;
                    }}>
                    {t('pages.membership')}
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FamilyMemberList;
